import { useState, useEffect, createContext, useContext, ReactNode } from "react";
import API from "../api/api";

interface User {
  id: number;
  nombre: string;
  correo: string;
  codigo_usuario: string;
  puntos: number;
  aciertos_partidos: number;
  aciertos_resultados: number;
}

interface AuthContextProps {
  user: User | null;
  setUser: (user: User | null) => void;
  loading: boolean;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      API.get("/auth/me") // Llama al endpoint /me
        .then(res => setUser(res.data.user))
        .catch(() => localStorage.removeItem("token")) // Si falla, elimina token
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};
